import { EnumCommodity } from '../../api'
import { PriceBase } from '../../api/Argentia/endpoints/versions/model/priceBase.model'
import { EnumMarketType, EnumPriceComponentReference, EnumRedondeo } from '../../api/Argentia/enums'
import { EnumHora, EnumQHora } from '../../api/Argentia/enums/hora'
import { EnumPriceCalculationType } from '../../api/Argentia/enums/priceCalculationType'
import { EnumPrecioUnitario } from '../../api/oData/enums/enumPrecioUnitario'
import { EnumPriceType } from '../../api/oData/enums/enumPriceType'

export enum TabsPriceType {
  cotization = 1,
  calculatedIndex = 3,
  parameter = 4,
  baseFormula = 5,
  apuntamiento = 9,
  baseComponents = 100, // 100 is used to avoid conflicts with other price types.
  parameterPeriod = 10
}

export interface PricingTableModel {
  id: number
  code: string
  description: string
  precioUnitario: EnumPrecioUnitario
  productType?: string
  startDate: Date
  endDate?: Date
  idPriceComponent?: number
  idPriceComponentType?: number
  idDummyPrice?: number
  idVersion?: number
  priceComponentTypeCode?: string
  priceComponentTypeDescription?: string
  priceType?: EnumPriceType
  priceComponentTypeReference?: EnumPriceComponentReference
  canEditPriceComponentType?: boolean
  canViewPriceComponentTypeInstances?: boolean
  rounding?: EnumRedondeo
  commodity?: EnumCommodity
  expression?: string
  relatedPriceComponentCount?: number
  marketType?: EnumMarketType
  priceCalculationType?: EnumPriceCalculationType
}

export interface PriceDetails {
  id: number
  code: string
  description: string | null
  precioUnitario: EnumPrecioUnitario
  marketType?: EnumMarketType | null
  empresa: number
  commodity: EnumCommodity | null
  priceType: EnumPriceType
  redondeo: EnumRedondeo
  relatedFuturePrice: number | null
  priceExpression: string
  priceCalculationType: EnumPriceCalculationType
  version: number
  conceptId?: number
  priceConceptId: number
}

export interface PriceValues {
  id: number
  value: number
  startDate: Date
  endDate: Date
  manual: boolean
  future: boolean
  hora: EnumHora
  qHora?: EnumQHora
  canEdit?: boolean
}

export interface Commodity {
  activeCommodity: EnumCommodity
}

export interface NewPriceModel {
  id?: number
  code?: string
  description?: string
  precioUnitario?: EnumPrecioUnitario
  marketType?: EnumMarketType
  commodity: EnumCommodity
  priceType: EnumPriceType
  redondeo?: EnumRedondeo
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
  expressionValid?: boolean | undefined
  referenceType?: EnumPriceComponentReference
}

export interface NewPriceModelResponse {
  id: number
  code: string
  description?: string
  precioUnitario?: EnumPrecioUnitario
  marketType?: EnumMarketType
  commodity: EnumCommodity
  priceType: EnumPriceType
  redondeo?: EnumRedondeo
  relatedFuturePrice?: number | null
  priceExpression?: string
  priceCalculationType?: EnumPriceCalculationType | null
  expressionValid?: boolean | undefined
}

export interface PriceVersion {
  id: number
  startDate: string
  endDate?: string
  priceCalculationType: EnumPriceCalculationType
  precioUnitario: EnumPrecioUnitario
  expression: string
  redondeo: EnumRedondeo
  version: number
  priceId: number
  price: PriceBase
}

export interface NewPriceVersion {
  id?: number
  startDate: Date
  endDate?: Date
  priceCalculationType: EnumPriceCalculationType
  precioUnitario: EnumPrecioUnitario
  expression: string
  redondeo: EnumRedondeo
  version: number
  price: PriceBase
}

export interface ModifiedVersion {
  method: string
  version: Partial<NewPriceVersion>
}
